import { 
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren, } from '@angular/core';
import { CommonService } from "src/app/common.service";
import { FormControlTemplatesDirective } from "../form-control-templates.directive";
import { FormControlTemplatesService } from "../form-control-templates.service";


@Component({
  selector: 'form-cards-templates',
  templateUrl: './form-cards-templates.component.html',
  styleUrls: ['./form-cards-templates.component.scss']
})
export class FormCardsTemplatesComponent implements OnInit {
  @ViewChildren(FormControlTemplatesDirective)
  templateRefs: QueryList<FormControlTemplatesDirective>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private _formControlTmpltService: FormControlTemplatesService,
    public commonService: CommonService,
    
  ) {}

  ngOnInit(): void {}

  shareAccountInfo($event,selectableData){
    console.log("shareAccountInfo",selectableData);
    $event.preventDefault();
    $event.stopPropagation();
    // let D=this._accountsService.shareAccountInfo(selectableData.accountNumber);
    // console.log("share",D);
  }

  ngAfterViewInit(): void {
    this._formControlTmpltService.cardsTmpltRefs = this.templateRefs;
  }
}